import { Shield, Star } from 'lucide-react';
import { useAppStore } from '../../store/appStore';

export default function ModeToggle() {
  const appMode = useAppStore((s) => s.appMode);
  const setAppMode = useAppStore((s) => s.setAppMode);

  const isParent = appMode.mode === 'parent';

  return (
    <div
      className="fixed top-0 right-0 z-50 p-3"
      style={{ paddingTop: 'calc(0.75rem + env(safe-area-inset-top))' }}
    >
      <div className="flex items-center gap-1 bg-white/85 backdrop-blur-md shadow-md rounded-full px-1.5 py-1 border border-white/60">
        {/* Parent option */}
        <button
          onClick={() => setAppMode('parent')}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 ${
            isParent
              ? 'bg-primary-600 text-white shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
          }`}
          aria-pressed={isParent}
          aria-label="Switch to Parent Mode"
        >
          <Shield size={12} />
          <span>Parent</span>
        </button>

        {/* Kid option */}
        <button
          onClick={() => setAppMode('kid')}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 ${
            !isParent
              ? 'bg-warm-400 text-white shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
          }`}
          aria-pressed={!isParent}
          aria-label="Switch to Kid Mode"
        >
          <Star size={12} />
          <span>Kid</span>
        </button>
      </div>
    </div>
  );
}
